import React from 'react'
import { useAppSelector } from '../redux'

import { selectAccess } from '../../slices/accessSlice'

export const PERMS = {
  ArticlesAdmin: 'articles.admin',
  ArticlesFull: 'articles.full',

  BillingAdmin: 'billing.admin',
  BillingView: 'billing.view',

  ContactsAdmin: 'contacts.admin',
  ContactsAudit: 'contacts.audit',
  ContactsFull: 'contacts.full',
  ContactsMerge: 'contacts.merge',
  ContactsOwn: 'contacts.own',

  ConversationsActive: 'conversations.active',
  ConversationsAdmin: 'conversations.admin',
  ConversationsBasic: 'conversations.basic',
  ConversationsFull: 'conversations.full',
  ConversationsMultichannel: 'conversations.multichannel',

  InboxesAdmin: 'inboxes.admin',
  InboxesFull: 'inboxes.full',

  IntegrationsAdmin: 'integrations.admin',

  NotesAdmin: 'notes.admin',
  NotesFull: 'notes.full',

  PeerAdmin: 'peer.admin',
  PeerFull: 'peer.full',

  SettingsAdmin: 'settings.admin',

  TagsAdmin: 'tags.admin',

  TasksAdmin: 'tasks.admin',
  TasksAudit: 'tasks.audit',
  TasksClose: 'tasks.close',
  TasksFull: 'tasks.full',
  TasksOwn: 'tasks.own',
  TasksTeam: 'tasks.team',

  TemplatesAdmin: 'templates.admin',

  UsersAdmin: 'users.admin',
  UsersBasic: 'users.basic',
  UsersFull: 'users.full',
  UsersSelf: 'users.self',

  AppPortal: 'app.portal',
  AppWorkspace: 'app.workspace'
}

export const PORTAL_PERMS = [
  PERMS.UsersFull,
  PERMS.UsersBasic,
  PERMS.UsersSelf,
  PERMS.ContactsFull,
  PERMS.ContactsAudit,
  PERMS.TasksOwn,
  PERMS.ConversationsBasic,
  PERMS.InboxesAdmin,
  PERMS.InboxesFull,
  PERMS.AppPortal
]

const useAccess = () => {
  const { permissions } = useAppSelector(selectAccess)

  // Handles array of permissions
  const hasPermission = React.useCallback(
    (perm: string | string[]) => {
      // Returns true if any of the array of permissions are granted
      if (Array.isArray(perm)) {
        for (const pm of perm) {
          if (permissions.includes(pm)) {
            return true
          }
        }

        return false
      }

      return permissions.includes(perm)
    },
    [permissions]
  )

  return hasPermission
}

export default useAccess
